







































































































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';

@Component
export default class DeviceApprovalDetail extends Mixins(DetailMixin) {
  @Prop(String) public id!: string;
  @Prop(Boolean) public consultView!: boolean;

  public tableCfg = FieldDefs;
  public url = this.getTableCfg(this.tableCfg, 'url');
  public apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');
  public headers = [
    {
      text: 'Onderdeel',
      value: 'desc'
    },
    {
      text: 'Softwareversie',
      value: 'software'
    },
    {
      text: 'Checksum',
      value: 'checksum'
    }
  ];
  public analogDigitalOptionList = [
    {
      value: 0,
      text: ''
    },
    {
      value: 1,
      text: 'Analoog'
    },
    {
      value: 2,
      text: 'Digitaal'
    }
  ];

  public initDeviceGroupId(rec) {
    if (rec.devicetype.devicegroup_id) {
      this.setDeviceGroupID(rec.devicetype.devicegroup_id);
    }
  }
}
